import { render, staticRenderFns } from "./ProjectTabs.vue?vue&type=template&id=455cf018&scoped=true&"
import script from "./ProjectTabs.vue?vue&type=script&lang=js&"
export * from "./ProjectTabs.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTabs.vue?vue&type=style&index=0&id=455cf018&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455cf018",
  null
  
)

export default component.exports